/* src/app/app.component.scss */
ion-split-pane {
  --side-max-width: 175px;
}
ion-menu ion-content {
  height: 100%;
}
ion-menu ion-content .main-logo {
  max-width: 90px;
  margin-left: 30px;
}
ion-menu ion-content::part(scroll) {
  display: flex;
  flex-flow: column nowrap;
}
ion-menu ion-content .header {
  width: 100%;
  margin-top: calc(var(--space-top) * 3);
  margin-bottom: calc(var(--space-bottom) * 5);
  padding: calc(env(safe-area-inset-top, 0) + var(--space-top)) var(--space-right) var(--space-bottom) var(--space-left);
  text-align: left;
}
ion-menu ion-content .content {
  flex: 1 0 auto;
}
ion-menu ion-content .content app-item {
  --icon-color: var(--ion-color-medium);
  --padding-left: 30px;
  --min-height: 56px;
  color: var(--ion-color-medium);
  font-weight: bold;
  margin: 0;
}
ion-menu ion-content .content app-item.selected {
  --icon-color: var(--ion-color-primary-contrast);
  color: var(--ion-color-primary-contrast);
  --item-background: var(--ion-color-primary);
}
ion-menu ion-content .footer {
  flex-shrink: 0;
  margin-bottom: var(--space-bottom);
  padding-bottom: env(safe-area-inset-bottom, 0);
}
ion-menu ion-content .footer .user-item {
  --icon-margin: calc(var(--space-right) / 2);
  --icon-font-size: 40px;
  --padding-bottom: 0;
}
ion-menu ion-content .footer .user-item ion-label h2 {
  font-weight: bold;
  color: #3C1A75;
}
ion-menu ion-content .footer app-item.log-out {
  --icon-color: var(--ion-color-danger);
  color: var(--ion-color-danger);
  border-bottom: 0px;
  font-weight: 700;
}
ion-menu ion-content ion-select::part(icon) {
  position: absolute;
  right: 15px;
}
/*# sourceMappingURL=app.component.css.map */
